import React, { PureComponent } from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Button, ButtonColor } from '@pegasus/ui-components/components/button';
import styles from './BannerContent.scss';
import { CtaTarget} from '@shared/types/mylounge'


interface BannerContentProps {
    text: string;
    ctaTarget?: CtaTarget | {};
    onButtonClick: (event: React.MouseEvent) => void;
}

export const BannerContent = ({ text, onButtonClick, ctaTarget }: BannerContentProps) => {
    const allWhitespaces = /^(\s)+$/;
    const validText = text && typeof text === 'string' && !allWhitespaces.test(text);
    const validTarget = !ctaTarget || !isEmpty(ctaTarget);

    return validText && validTarget && (
        <div styleName="wrapper">
            <div styleName="button-container">
                <Button color={ButtonColor.bright} onClick={onButtonClick} fullWidth>
                    { text }
                </Button>
            </div>
        </div>
    );
}


export default CSSModules(BannerContent, styles, { allowMultiple: true });
